import styled from "styled-components";
import Colors from "../../Constant/Colors";
import SmartImage from "../../Components/SmartImage";
import { STYLES } from "../../Constant/Theme";

export const Container = styled.div`
  height: 83%;
  width: ${(props) => (props.isInstructor ? "74%" : "95%")};
  
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
export const ChartContent = styled.div`
  /* height: 200px; */
  width: 98%;
  min-width: 480px;
  margin-top: 10px;
  padding: 7px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  @media only screen and (max-width: 600px) {
    min-width: 33%;
    width: 100%;
  }
`;
export const EachChart = styled.div`
  box-sizing: border-box;
  height: 110px;
  width: 32%;
  min-width: 120px;
  padding: 10px;
  background-color: ${Colors.whiteThemeColor};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${STYLES.borderShadow};
  @media only screen and (max-width: 600px) {
    min-width: 50px;
  }
`;

export const Icon = styled(SmartImage)`
  margin-top: 10px;
  align-self: center;
  object-fit: contain;
`;
